// extracted by mini-css-extract-plugin
module.exports = {"code":"classN_code__cc1Bk"};